import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ApiService } from './api.service';
import { Users } from 'app/modal/users';
import { Router } from '@angular/router';
import { SnackBarService } from './snack-bar.service';
import { UsersPagination } from "../modal/users-pagination";

@Injectable({ providedIn: 'root' })
export class UsersService {

    private _user: BehaviorSubject<Users | null> = new BehaviorSubject(null);
    private _users: BehaviorSubject<Users[] | null> = new BehaviorSubject(null);

    private _usersPagination: BehaviorSubject<UsersPagination | null> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(private _apiService: ApiService,
        private _router: Router,
        private _snackBarService: SnackBarService) {
    }

    get users$(): Observable<Users[]> {
        return this._users.asObservable();
    }

    get usersPagination$(): Observable<UsersPagination> {
        return this._usersPagination.asObservable();
    }

    get user$(): Observable<Users> {
        return this._user.asObservable();
    }


    getUsers(): Observable<Users[]> {
        this._user.next(null);
        return this._apiService.sendGETRequest('/v1/Users/findAll').pipe(
            tap((response: Users[]) => {
                this._users.next(response);

            }),
        );
    }

    getUsersWithPagination(page: number, size: number): Observable<UsersPagination> {
        this._user.next(null);
        return this._apiService.sendGETRequest('/v1/Users/getUsersByCreator?page=' + page + "&size=" + size).pipe(
            tap((response: UsersPagination) => {
                this._usersPagination.next(response);
            }),
        );
    }

    getUsersById(id: string) {
        return this._apiService.sendGETRequest('/v1/Users/findById?id=' + id).pipe(
            tap((response: any) => {
                this._user.next(response);
            }),
        );
    }

    redirectToUserHome() {
        const user = JSON.parse(localStorage.getItem("loggedIn-user-data") || '{}');
        if (user && user.role === 'BLOGGER') {
            this._router.navigate(['/admin/blog']);
            return;
        }

        this.getHomePageURL()
            .subscribe((response: any) => {
                this._router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
                    this._router.navigate([response.redirectURL || '/home/dashboard'])
                );
            },
                (response) => {
                    this._router.navigate(['/home/dashboard']);
                    //this._snackBarService.openSnackBar(response?.error?.message);
                }
            );
    }

    updateUserPersonalInformation(userid: number, user: any) {
        return this._apiService.sendPOSTRequest('/v1/Users/updatePersonalInfo/' + userid, user).pipe(
            tap((response: any) => {
            }),
        );
    }

    updateUserDemographicInformation(userid: number, address: any) {
        return this._apiService.sendPOSTRequest('/v1/Users/updateAddress/' + userid, address).pipe(
            tap((response: any) => {
            }),
        );
    }

    updateUserTaxInformation(userid: number, taxInfo: any) {
        return this._apiService.sendPOSTRequest('/v1/Users/updateTaxInfo/' + userid, taxInfo).pipe(
            tap((response: any) => {
            }),
        );
    }

    updateUserSecurityInformation(securityInfo: any) {
        return this._apiService.sendPOSTRequest('/v1/Users/changePassword', securityInfo).pipe(
            tap((response: any) => {
            }),
        );
    }

    checkUsernameAvailability(value: string): any {
        return this._apiService.sendGETRequest('/unsecure/Users/checkUsernameAvailability?username=' + value).pipe(
            tap((response: any) => {
            }),
        );
    }

    newMemberValue(newMember) {
        this._user.next(newMember);
    }

    createUser(userProfile: any): Observable<any> {
        return this._apiService.sendPOSTRequest('/v1/Users/create', userProfile).pipe(
            tap((response: any) => {
            }),
        );
    }

    updateActiveRole(userid: number, roleid: number) {
        return this._apiService.sendGETRequest('/v1/Users/updateActiveRole/' + userid + '/' + roleid).pipe(
            tap((response: any) => {
            }),
        );
    }

    updateActiveFacility(userid: number, id: number) {
        return this._apiService.sendGETRequest('/v1/Users/updateActiveFacility/' + userid + '/' + id).pipe(
            tap((response: any) => {
            }),
        );
    }

    getHomePageURL() {
        return this._apiService.sendGETRequest('/v1/ApplicationSetting/getHomePageURL').pipe(
            tap((response: any) => {
            }),
        );
    }

    updateUserStatus(userid: number, status: boolean) {
        return this._apiService.sendGETRequest('/v1/Users/updateUserStatus/' + userid + '/' + status).pipe(
            tap((response: any) => {
            }),
        );
    }

}
